import ajax from '../../helpers/ajax'
import { trackEvent } from '@/analytics/track'
import webShareSupported from '@/utils/web-share-supported'

export default {
  loadNextStep({state, dispatch}) {
    state.previousStepKind = state.currentStepKind
    dispatch('loadStep')
  },

  loadStep({state, commit, dispatch, getters}) {
    const params = {
      web_share_supported: webShareSupported()
    }
    if (state.repeatedAction !== null) {
      params.re_sign = state.repeatedAction
    }

    // If there is a "partner" URL parameter, pass it along
    const urlParams = new URLSearchParams(new URL(window.location.href).search)
    if (urlParams.has('after_action')) {
      params.after_action = urlParams.get('after_action')
    }
    if (urlParams.has('partner')) {
      params.partner = urlParams.get('partner')
    }

    ajax.get({
      url: state.previousStepKind ? getters.nextStepUrl : getters.firstStepUrl,
      params: params,
      successHandler: (resp) => {
        const { daisyChainStepKind:kind, stepData:data, showNextStep:hasNextStep, stepsProgress, trackingData:tracking } = resp

        commit('setCurrentStep', { kind, data, hasNextStep, stepsProgress, tracking })

        if (state.currentStepKind) {
          dispatch('trackStepEvent')
        }
      }
    })
  },

  trackStepEvent({getters}) {
    trackEvent(
      getters.trackingEventNameForCurrentStep,
      getters.trackingEventDataForCurrentStep,
      getters.trackingIdentity
    )
  }
}
